import type { CheckboxConfig } from '#types/config/components/vf/checkbox'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    control: {
      size: {
        sm: 'mt-1'
      },
      variant: {
        base: {
          default: 'ring-grey-40',
          disabled: 'bg-grey-80 ring-grey-50',
          disabledSelected: 'bg-grey-50 ring-grey-50 c-white',
          error: 'ring-red-30',
          selected: 'ring-grey-40'
        },
        inverse: {
          default: 'ring-grey-60',
          disabled: 'bg-grey-20 ring-grey-50',
          disabledSelected: 'bg-grey-50 ring-grey-50 c-white',
          error: 'ring-red-60',
          selected: 'ring-grey-60'
        }
      }
    },
    label: {
      size: {
        md: 'text-base',
        sm: 'text-base'
      },
      variant: {
        base: {
          default: 'c-grey-10',
          disabled: 'c-grey-30'
        },
        inverse: {
          default: 'c-white',
          disabled: 'c-grey-60'
        }
      }
    },
    wrapper: {
      size: {
        md: 'gap-x-4',
        sm: 'gap-x-2'
      }
    }
  }
} satisfies RecursivePartial<CheckboxConfig>
